const NOTIFICATION_MODAL_SET_STATE: 'NOTIFICATION_MODAL_SET_STATE' = 'NOTIFICATION_MODAL_SET_STATE';

export default {
  NOTIFICATION_MODAL_SET_STATE,
};
